import { createSlice } from "@reduxjs/toolkit";

export const reportBilling = createSlice({
  name: "reportBilling",
  initialState: {
    value: false, // default state
  },
  reducers: {
    // reducers action
    setReportBilling: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setReportBilling } = reportBilling.actions;
export default reportBilling.reducer;
